export default (axios, baseURL) => async () => {
  const url = '/v1/vendors';

  const axiosConfig = {
    method: 'GET',
    baseURL,
    url,
    params: { type: 'excursion' }
  };
  const axiosResponse = await axios(axiosConfig);

  if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
    throw new Error('Invalid response from gateway');
  }
  return axiosResponse.data;
};
